export default "__VITE_ASSET__B9WKJWa9__"